import React from 'react';
import '../styles/presentation.css'; 

export default function Presentation() {
  return (
    <section className="presentation">
  <div className="presentation-container">
    <img
      src="/dibujos/optimized/portafolio2.png"
      alt="Ilustración principal"
      className="presentation-image"
    />
    <h1 className="presentacion-titulo">
      Hola! soy Dolly, una ilustradora digital de Argentina.
      <br />
      Mi estilo navega el semirealismo y pngTubers, y a través de Krita doy vida a los retratos con alma, 
      buscando capturar eso invisible que los hace únicos.
    </h1>
  </div>
</section>

  );
}